import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import { reducer as notificationsReducer } from 'reapop'
import serviceReducer from './reducers/services'
import uiReducer from './features/ui/reducer'

export default combineReducers({
    form: formReducer,
    notifications: notificationsReducer(),
    services: serviceReducer.services,
    ui: uiReducer
})



// WEBPACK FOOTER //
// ./src/reducers.js